import { IDeepCopy, IToString } from "@common/interfaces";
import { IEquals } from "@suite/common/interfaces/i-equals";

export class MultiValue<T> extends Array<T> implements IDeepCopy<MultiValue<T>>, IEquals<MultiValue<T>>, IToString {

	constructor(...items: T[]) { 
		super(...items);
		Object.setPrototypeOf(this, MultiValue.prototype);
	}

	public clear() {
		this.length = 0;
	}

	public set(prop: T) {
		// this.cachedKeys = null;
		const index = this.indexOf(prop);
		if (index == -1) this.push(prop);
	}

	public delete(prop: T) {
		// this.cachedKeys = null;
		const index = this.indexOf(prop);
		this.splice(index, 1);

	}

	public get(prop: T): T | undefined {
		return this.find((v: T) => v === prop);
	}

	// public getProperties(): Array<T> {
	// 	return this;
	// }

	public equals(target: MultiValue<T>): boolean {
		if (!target) return false;
        if (!target.get) return false;
		for (let prop of this) {
			if (!target.get(prop)) return false;
		}
		for (let prop of target) {
			if (!this.get(prop)) return false;
		}
		return true;
	}

	public hasKey(key: T): boolean {
		return this.some((v: T) => v === key);
	}

	public hasValues(): boolean {
		return !!this.length;
	}

	public toString(): string {
		let ret = "";
		let first = true;
		for (let prop of this) {
			if (first) {
				first = false;
				ret += prop.toString();
			} else {
				ret += ", " + prop.toString();
			}
		}
		return ret;
	}

	public toJSON() {
		return Object.values(this);
	}

	public fromJSON(json: string): MultiValue<T> {
		let obj = JSON.parse(json);
		let ret = new MultiValue<T>();
		if (obj && obj.length) {
			for (let v of obj) {
				ret.set(<T>v);
			}
		}
		return ret;
	}

	public deepCopy(): MultiValue<T> {
		let ret = new MultiValue<T>();
		for (let prop of this) {
			ret.set(prop);
		}
		return ret;
	}
}
